import React from 'react'
import { PermissionType } from '@golden/gdk-admin'
import Box from '@material-ui/core/Box'
import PlayerAgentsMemoForm, { createSearchToRequest, normalizeDepartment } from '../../../components/admin/player/PlayerAgentsMemoForm'
import PlayerAgentsMemoTable from '../../../components/admin/player/PlayerAgentsMemoTable'
import { useReload, useRequestFromSearch } from '../../../utils/default/ComplexFlowHook'
import { useLocation, useNavigate } from 'react-router-dom'
import allRoutes from '../../../components/admin/route/route'
import { useChecker } from '../../../utils/admin/AdminRouteHook'

const PlayerAgentsMemoPage: React.FC = () => {
  const { reload, reloadFlag } = useReload()
  const canReadRc = useChecker([PermissionType.PLAYER_MANAGEMENT_AGENTS_MEMO_RC_READ])
  const canReadCs = useChecker([PermissionType.PLAYER_MANAGEMENT_AGENTS_MEMO_CS_READ])
  const searchToRequest = React.useMemo(() => createSearchToRequest(canReadRc, canReadCs), [canReadRc, canReadCs])
  const request = useRequestFromSearch({ searchToRequest })
  const navigate = useNavigate()

  const handleReload = () => {
    if (!request) {
      navigate(allRoutes.playerAgentsMemo.encodePath({ search: { department: normalizeDepartment(undefined, canReadRc, canReadCs), page: 1 }, param: {} }))
      return
    }
    reload()
  }
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerAgentsMemoForm reload={handleReload} />
      </Box>
      <Box paddingTop={3}>
        <PlayerAgentsMemoTable reload={handleReload} reloadFlag={reloadFlag} />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerAgentsMemoPage)
